// @ts-check
import React from 'react'
import cn from 'classnames'
import { isEmpty, isNil } from 'ramda'
import { InfoIcon, ValidIcon } from '..'
import styles from './style.css'

const isEmptyOrNull = (value) => isNil(value) || isEmpty(value)

/**
 * @param {{
 * value: string,
 * htmlFor: string,
 * valid: boolean,
 * title?: string,
 * info?: string
 * className?: string }} props
*/
const Label = ({ value, htmlFor, valid, title, info, className }) => {
  const imgValidClass = valid ? styles.valid : styles.invalid
  return !isEmptyOrNull(value) ? (
    <div className={styles.labelBlock}>
      <ValidIcon className={cn(styles.image, imgValidClass)} />
      <label
        className={cn(styles.label, className)}
        htmlFor={htmlFor}
        title={title}
      >
        {value}
      </label>
      {info && <InfoIcon text={info} />}
    </div>
  ) : null
}

export { Label }
